export default {
  modals: {
    delete_payment_method: {
      title: 'Sei sicuro di voler rimuovere questo metodo di pagamento?',
    },
  },
  buttons: {
    confirm: 'Conferma',
    cancel: 'Annulla',
  },
  toasts: {
    failed_to_delete_payment_method: 'Impossibile eliminare il metodo di pagamento',
    payment_method_deleted: 'Metodo di pagamento eliminato',
  },
};
